/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useGetStartedStyles = makeStyles(() => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  info: {
    paddingTop: '30px',
    // maxWidth: '700px',
    textAlign: 'center',
    whiteSpace: 'pre-line',
  },
  buttons: {
    paddingTop: '50px',
  },
}));
